import { Button } from '@mui/material';
import InputWrapper from '../InputWrapper';
import CopySection from '../../../businesses/SettingsSection/CopySection';

interface Props {
  id: string;
  label: string;
  value: string;
  disabled?: boolean;
  tooltip?: string;
  isLabelMultiline?: boolean;
  footerAction?: {
    label: string;
    onClick: () => void;
  };
}

function Copy({
  id,
  value,
  label,
  tooltip,
  isLabelMultiline,
  disabled,
  footerAction,
}: Props) {
  return (
    <InputWrapper
      label={label || ''}
      name={id.toString()}
      tooltip={tooltip}
      isLabelMultiline={isLabelMultiline}>
      <CopySection
        copy={{
          content: value,
          disabled,
        }}
        containerSx={{
          width: '100%',
        }}
      />
      {footerAction && (
        <Button
          variant="link"
          onClick={footerAction.onClick}
          sx={{
            minWidth: '0',
            alignSelf: 'flex-start',
            fontWeight: 600,
          }}>
          {footerAction.label}
        </Button>
      )}
    </InputWrapper>
  );
}

export default Copy;
